"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangesAPI = void 0;
const base_1 = require("../base");
class ChangesAPI extends base_1.BaseAPI {
    /**
     * Get a list of all of the movie ids that have been changed in the past 24 hours. You can query
     * it for up to 14 days worth of changed IDs at a time with the start_date and end_date query
     * parameters. 100 items are returned per page.
     *
     * @see https://developers.themoviedb.org/3/changes/get-movie-change-list
     */
    async movie(filters) {
        const path = this.getPath('/movie/changes', filters);
        return this.get(path);
    }
    /**
     * Get a list of all of the TV show ids that have been changed in the past 24 hours. You can query
     * it for up to 14 days worth of changed IDs at a time with the start_date and end_date query
     * parameters. 100 items are returned per page.
     *
     * @see https://developers.themoviedb.org/3/changes/get-tv-change-list
     */
    async tv(filters) {
        const path = this.getPath('/tv/changes', filters);
        return this.get(path);
    }
    /**
     * Get a list of all of the person ids that have been changed in the past 24 hours. You can query
     * it for up to 14 days worth of changed IDs at a time with the start_date and end_date query
     * parameters. 100 items are returned per page.
     *
     * @see https://developers.themoviedb.org/3/changes/get-person-change-list
     */
    async person(filters) {
        const path = this.getPath('/person/changes', filters);
        return this.get(path);
    }
}
exports.ChangesAPI = ChangesAPI;
